import React from "react";
import { motion } from "framer-motion";

export default function AppLoader() {
  const dots = [0, 1, 2, 3, 4];

  return (
    <div className="h-screen w-screen flex items-center justify-center bg-white relative overflow-hidden ">
      {/* Ripple animation background */}
      <motion.div
        className="absolute w-80 h-80 rounded-full bg-purple-100"
        initial={{ scale: 0, opacity: 0.6 }}
        animate={{ scale: [0.8, 1.6], opacity: [0.6, 0] }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />
      {/* Central animated icon or brand */}
      <motion.div
        className="w-20 h-20 bg-[#9481ce] rounded-full flex items-center justify-center shadow-lg z-10"
        animate={{
          y: [0, -10, 0],
        }}
        transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: "easeInOut",
        }}
      >
        <span className="text-white font-bold text-2xl">S</span>
      </motion.div>
      {/* Dots loader */}
     
    </div>
  );
}



 {/* <div className="absolute bottom-16 flex gap-2">
        {dots.map((_, i) => (
          <motion.div
            key={i}
            className="w-3 h-3 rounded-full bg-[#9481ce]"
            animate={{
              y: [0, -6, 0],
            }}
            transition={{
              duration: 0.6,
              repeat: Infinity,
              delay: i * 0.15,
              ease: "easeInOut",
            }}
          />
        ))}
      </div> */}